var map = {
	"./Group.png": 1730,
	"./apk.png": 9745,
	"./bazar.png": 8797,
	"./google-play.png": 1019,
	"./logo.png": 2806,
	"./panguin-logo.png": 9695,
	"./pwa.png": 7399
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;